import { useMutation } from "@tanstack/react-query";
import { useAxios, useApiResponseParser } from "../";

export default function useUserRoles() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useListByUser() {
        return useMutation({
            mutationFn: (parameters: { userId?: string; OrganizationId?: string } = {}) =>
                axiosPrivate
                    .get(`/v1/user-roles`, {
                        params: {
                            ...(parameters.userId ? { UserId: parameters.userId } : {}),
                            ...(parameters.OrganizationId
                                ? { OrganizationId: parameters.OrganizationId }
                                : {}),
                        },
                    })
                    .then(parseSuccessResponseData),
        });
    }

    function useAssign() {
        return useMutation({
            mutationFn: (parameters: { UserId: string; RoleId: string; OrganizationId: string }) =>
                axiosPrivate.post(`/v1/user-roles/assign`, parameters).then(parseSuccessResponseData),
        });
    }

    function useRemove() {
        return useMutation({
            mutationFn: (parameters: { Id: string; OrganizationId: string }) =>
                axiosPrivate
                    .delete(`/v1/user-roles/${parameters.Id}`, {
                        params: { OrganizationId: parameters.OrganizationId },
                    })
                    .then(parseSuccessResponseData),
        });
    }

    function useSync() {
        return useMutation({
            mutationFn: (parameters: {
                UserId: string;
                RoleIds: string[];
                OrganizationId: string;
            }) => axiosPrivate.post(`/v1/user-roles/sync`, parameters).then(parseSuccessResponseData),
        });
    }

    return { useListByUser, useAssign, useRemove, useSync };
}
